'use strict';

let $body = $('body'),
    $window = $(window),
    isMobileDevice = Modernizr.mq('(max-width: 1024px)');

import mCustomScrollbar from 'mCustomScrollbar';

import './_modernizr';
import { debounce } from './_helper';
import { gsap } from 'gsap';

/////////////////////////////
// Select Box Materializer //
/////////////////////////////


$(() => {
    // Ripple Effect
    let $rippleEffect = $('button, .cta');

    $rippleEffect.on('click', function (e) {
        let $this = $(this);

        if (!$this.hasClass('disabled')) {
            ripple(e, $this);
        }
    });


    // Progress Bar
    $('.progress').each(function () {
        let $this = $(this),
            $progressBar = $this.find('.progress-bar');

        if ($progressBar.data('value') !== undefined) {
            $progressBar.css({ width: $progressBar.data('value') + '%' });
        }
    });

    $window.on('resize', debounce(function () {
        isMobileDevice = Modernizr.mq('(max-width: 1024px)');
    }, 250));
});



//////////////
// Toaster  //
//////////////
let toasterInd = 0;
let toaster = function (msg, className) {
    // Alert Toaster
    let popupAlert = doT.template($('#toaster-tmp').html()),
        _className = typeof className !== 'undefined' ? className : '',
        obj = {
            ind: toasterInd,
            message: msg,
            className: _className
        };

    if (!$('.toaster-wrap').length) {
        $('#main').after('<div class="toaster-wrap" />');
    }

    $('.toaster-wrap').append(popupAlert(obj));

    let toaster = '.toaster' + toasterInd;

    gsap.to(toaster, {duration: 0.75, 
        scale: 1,
        ease: "expo.inOut"
    });

    gsap.to(toaster, {duration: 0.75, 
        autoAlpha: 0,
        scale: 0.5,
        ease: "expo.inOut",
        delay: 5,
        onComplete: function () {
            $(toaster).remove();
        }
    });

    $(toaster).on('click', function (e) {
        e.preventDefault();

        gsap.to($(this), {duration: 0.75, 
            autoAlpha: 0,
            scale: 0.5,
            ease: "expo.inOut",
            onComplete: function () {
                $(toaster).remove();
            }
        });
    });

    toasterInd++;
};

/* Close toaster displayed after form submission.
** Keep this block outside of the previous toaster function,
** as it is an additional functionality needed only for form submission
*/
$('.js-dismiss').on('click', function (e) {
    e.preventDefault();

    let $toaster = $(this).closest('.toaster');

    gsap.to($toaster, {duration: 0.75, 
        autoAlpha: 0,
        scale: 0.5,
        ease: "expo.inOut",
        onComplete: function () {
            $toaster.remove();
        }
    });
});

/* Display toaster after form submission.
** Keep this block outside of the previous toaster function,
** as it is an additional functionality needed only for form submission
*/
window.onload = function()
{
    gsap.to($('.toaster.submit'), {duration: 0.75, 
        scale: 1,
        ease: "expo.inOut"
    });
}




///////////////////
// Ripple Effect //
///////////////////
let inc = 0;
let ripple = function (e, el) {
    if ($('.no-svg').length || el.find('svg').length) {
        return false;
    }

    // create SVG element
    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
        g = document.createElementNS('http://www.w3.org/2000/svg', 'g'),
        circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle'),
        x = e.offsetX,
        y = e.offsetY;

    if (x == undefined) {
        return false;
    }

    if (el.outerWidth() < 0) {
        return false;
    }

    svg.setAttributeNS(null, 'class', 'ripple ripple' + inc);
    g.setAttributeNS(null, 'transform', 'translate(' + x + ', ' + y + ')');
    circle.setAttributeNS(null, 'r', (parseInt(el.outerWidth()) + x));

    svg.appendChild(g);
    g.appendChild(circle);
    el.append(svg);

    let $ripple = el.find('.ripple' + inc);
    gsap.from($ripple.find('circle'), {duration: 1.5, 
        attr: { r: 0 },
        opacity: 0.75,
        ease: "expo.inOut",
        onComplete: function () {
            $ripple.remove();
        }
    });

    inc++;
};

export { toaster, ripple };